import { render, staticRenderFns } from "./unread.vue?vue&type=template&id=645d7866&scoped=true"
import script from "./unread.vue?vue&type=script&lang=js"
export * from "./unread.vue?vue&type=script&lang=js"
import style0 from "./unread.vue?vue&type=style&index=0&id=645d7866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d7866",
  null
  
)

export default component.exports